<template>
    <div>
        <h1 class="text-center">{{$t('message.signup_heading')}}</h1>
        <p class="text-center"><a :href="$t('message.personal_data_link')" target="_blank"><i class="fa fa-info-circle"></i> {{$t('message.personal_data_processing')}}</a></p>
        <vue-form-generator :schema="schema" :model="model" :options="formOptions" @validated="onValidated"/>
    </div>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {REG_REQUEST} from '../_store'
    import mixins from '../modules/mixins'

    export default {
        name: 'Signup',
        mixins: [mixins],
        data () {
            return {
                validForm: false,
                model: {
                    name: this.$route.query.email || '',
                    password: '',
                    password2: '',
                    showPassword: false
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'email',
                        i18n: {
                            label: 'message.email'
                        },
                        inputName: 'email',
                        model: 'name',
                        required: true,
                        validator: VueFormGenerator.validators.email
                    }, {
                        type: 'input',
                        inputType: 'password',
                        i18n: {
                            label: 'message.password'
                        },
                        inputName: 'password',
                        model: 'password',
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'password',
                        i18n: {
                            label: 'message.password_repeat'
                        },
                        model: 'password2',
                        required: true,
                        validator: [VueFormGenerator.validators.string,
                            (value, field, model) => {
                                let pass = model.password
                                let confPass = value
                                if (pass !== confPass) {
                                    return ["Passwords don't match."]
                                } else {
                                    return []
                                }
                            }
                        ]
                    }, {
                        type: 'checkbox',
                        i18n: {
                            label: 'message.show_password'
                        },
                        label: this.$t('message.show_password'),
                        model: 'showPassword'
                    }, {
                        type: 'submit',
                        buttonText: this.$t('message.signup'),
                        i18n: {
                            buttonText: 'message.signup'
                        },
                        validateBeforeSubmit: true,
                        onSubmit: this.login
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChange: true
                }
            }
        },
        methods: {
            onValidated (isValid) {
                this.validForm = isValid
            },
            login () {
                if (!this.validForm) {
                    return
                }
                this.model.name = this.model.name.trim()
                storage.dispatch(REG_REQUEST, {
                    name: this.model.name,
                    password: this.model.password
                }).then((resp) => {
                    this.$router.push('/')
                }).catch(err => {
                    this.$b_notify({
                        type: 'danger',
                        content: err.response.data.message || err.message
                    })
                })
            }
        },
        watch: {
            'model.showPassword' (visible) {
                const inputType = visible ? 'text' : 'password'
                this.schema.fields[1].inputType = inputType
                this.schema.fields[2].inputType = inputType
            }
        }
    }
</script>

<style scoped>
    .vue-form-generator {
        max-width: 500px;
        margin: 0px auto;
        padding: 20px;
        border: 1px solid #e4e4e4;
        box-shadow: rgba(0, 0, 0, 0.1) 0 3px 6px 0;
        border-radius: 4px;
    }
   .vue-form-generator .field-wrap input[type=submit] {
        background-color: black !important;
   }
</style>
